import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { HomePage } from '../home/home';

/**
 * Generated class for the EsperaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-espera',
  templateUrl: 'espera.html',
})
export class EsperaPage {
  pedidos: any = []
  pedidosres: any = []
  resBusq: any = []
  busqueda: any = ''
  skip = 0
  fin = 9
  constructor(
    public navCtrl: NavController,
    public alertCtrl: AlertController,
    public navParams: NavParams
    ) {
  }

  ionViewDidEnter() {
    this.pedidosres = []
    this.pedidos = []
    this.skip = 0
    this.fin = 9
    if (window.localStorage.getItem('pedidoEspera')) {
      this.pedidosres = JSON.parse(window.localStorage.getItem('pedidoEspera'))
      this.pedidosres.sort(function(a, b) {
        return b.nro - a.nro;
      });
      this.pedidos = this.pedidosres.filter(el=>{
        return el
      }).slice(0, 9)
      this.skip += 10
      this.fin += 10
    }
  }

  doInfinite(inifiteScroll) {
    if (this.resBusq && this.resBusq.length > 0) {
      this.pedidos = this.pedidos.concat(this.resBusq.slice(this.skip, this.fin))
    } else {
      this.pedidos = this.pedidos.concat(this.pedidosres.slice(this.skip, this.fin))
    }
    this.skip += 10
    this.fin += 10
    inifiteScroll.complete()
  }

  transform(value) {
    if(value){
      let val = value
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  irPedido(item) {
    window.localStorage.setItem('pedido', JSON.stringify(item))
    let cliente = item.cliente
    this.navCtrl.push(HomePage,{pedido:true, cliente, espera: true})
  }

  calcularCantidadProd(item) {
    let acum = 0
    item.forEach(el=>{
      acum += parseFloat(el.cant)
    })
    return acum
  }

  eliminarPedido(item) {
    this.alertCtrl.create({
      title: 'Atención',
      subTitle: '¿Estás seguro que deseas eliminar este pedido?',
      cssClass:'alrt',
      buttons:[
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'btn'
        },
        {
          text:'Aceptar',
          cssClass: 'btnAceptar',
          handler:()=>{
            let ped = this.pedidosres.filter(el=>{
              return el.nro !== item.nro
            })
            window.localStorage.setItem('pedidoEspera', JSON.stringify(ped))
            this.pedidosres = JSON.parse(window.localStorage.getItem('pedidoEspera'))
            this.pedidos = this.pedidosres.filter(el=>{
              return el
            }).slice(0, this.fin)
          }
        }
      ]
    }).present()
  }

  buscar(event=null) {
    this.resBusq = this.pedidosres.filter((el) => {
      let arry = this.busqueda.split(' ')
      if (arry.length === 1) {
        return el.vendedor.ven_des.toLowerCase().indexOf(this.busqueda.toLowerCase()) > -1
          || el.cliente.cli_des.toLowerCase().indexOf(this.busqueda.toLowerCase()) > -1
      } else {
        let cont = 0
        let cont2 = 0
        for (let i = 0; i < arry.length; i++) {
          if (el.vendedor.ven_des.toLowerCase().indexOf(arry[i].toLowerCase()) > -1) {
            cont++
          }
          if (el.cliente.cli_des.toLowerCase().indexOf(arry[i].toLowerCase()) > -1) {
            cont2++
          }
          el.puntuacion = (cont > cont2) ? cont : cont2
        }
        if (cont > 0 || cont2 > 0) {
          return el
        }
      }
    })
    this.resBusq.sort(function(a, b) {
      return b.puntuacion - a.puntuacion;
    });
    this.skip=0
    this.fin=9
    this.pedidos = this.resBusq.slice(this.skip, this.fin)
    this.skip+=10
    this.fin+=10
  }

  reset(){
    if(this.busqueda.length === 0) {
      this.pedidos = this.pedidosres.filter(el=>{
        return el
      }).slice(0, 9)
      this.skip = 10
      this.fin = 19
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/espera/espera.ts